import { styled } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";

const ReviewDiffTableCell = styled(TableCell)(({ isdiff = undefined }) => ({
  backgroundColor: isdiff ? "rgba(233, 20, 20, 0.42)" : "transparent",
  padding: "6px 10px",
}));

export default ReviewDiffTableCell;
